
import {
    IS_LOADING,
    SET_PLANS,
    SET_EXPANDED_PLAN_ID,
    PLANS_TAB_INDEX,
} from "./siteMonitoringConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import {
    adaptPlanForDb,
    adaptPlanForMyOpen,
    adaptPlanForOpenERP,
    adaptPlanFromOpenERP,
} from "./siteMonitoringCast";
import moment from "moment";
import db from "../../db";
import { getSiteMonitoring, setSelectedTab } from "./siteMonitoringActions";
import { clearEditingNote } from "./noteActions";
import { getBase64ImageWithHeader } from "../../utils";

function siteMonitoringsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "site_monitoring_plan",
        isLoading: value,
    };
}

export function setPlansAction(plans) {
    return {
        type: SET_PLANS,
        plans,
    };
}

export function setExpandedPlanIdAction(expandedPlanId) {
    return {
        type: SET_EXPANDED_PLAN_ID,
        expandedPlanId,
    };
}

export function getPlans(siteMonitoring) {
    return (dispatch) => {
        dispatch(siteMonitoringsIsLoading(true));
        db.SiteMonitoringPlan.filter((plan) => {
            return plan.affair_id === siteMonitoring.id;
        })
            .toArray()
            .then((plans) => {
                let transformedPlans = [];
                plans
                    .sort(sortByName)
                    .forEach((l) => transformedPlans.push(adaptPlanForMyOpen(l)));

                dispatch(setPlansAction(transformedPlans));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : planActions - getPlans", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des plans !",
                    })
                );
                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

function sortByName(planA, planB) {
    if (!planA.name) return 0;

    return planA.name.localeCompare(planB.name);
}

export function createPlan(siteMonitoring, user) {
    return (dispatch) => {
        let newPlan = {
            affair_id: siteMonitoring.id,
            id: 0,
            create_uid: user.id,
            create_date: moment(),
            file_id: "",
            name: "",
            data: [],
        };

        const headers = new Headers({ "Content-Type": "application/json" });

        let planForOpenErp = adaptPlanForOpenERP(newPlan);

        const body = {
            plan: planForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));
        fetchWithTimeout("/api/v1/siteMonitorings/plans/create", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((newPlanId) => {
                newPlan.id = newPlanId;
                db.SiteMonitoringPlan.add(adaptPlanForDb(newPlan));
                dispatch(getPlans(siteMonitoring));
                dispatch(setExpandedPlanId(newPlan.id));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : planActions - createPlan: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la création du plan",
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function deletePlan(siteMonitoring, plan, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let planForOpenErp = adaptPlanForOpenERP(plan);

        const body = {
            plan: planForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));
        plan.deleted = true;
        db.SiteMonitoringPlan.delete(plan.id);

        dispatch(getPlans(siteMonitoring));
        dispatch(setExpandedPlanId(null));
        dispatch(siteMonitoringsIsLoading(false));
        fetchWithTimeout("/api/v1/siteMonitorings/plans/delete", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                plan.deleted = true;
                db.SiteMonitoringPlan.delete(plan.id);

                dispatch(getPlans(siteMonitoring));
                dispatch(setExpandedPlanId(null));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : planActions - deletePlan: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la suppression du plan",
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function savePlan(siteMonitoring, plan, user, onPlanUpdated) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let planForOpenErp = adaptPlanForOpenERP(plan);

        const body = {
            plan: planForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));

        fetchWithTimeout("/api/v1/siteMonitorings/plans/save", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                db.SiteMonitoringPlan.update(plan.id, adaptPlanForDb(plan)).then(() => {
                    if (onPlanUpdated && typeof onPlanUpdated === 'function')
                        onPlanUpdated();
                });

                dispatch(getPlans(siteMonitoring));
                dispatch(setExpandedPlanId(plan.id));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : planActions - savePlan: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la sauvegarde du plan",
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function setExpandedPlanId(expandedPlanId) {
    return (dispatch) => {
        dispatch(setExpandedPlanIdAction(expandedPlanId));
    };
}

export function synchronizePlans(serverSiteMonitoring) {
    return (dispatch) => {
        db.SiteMonitoringPlan.filter((plan) => {
            return plan.affair_id === serverSiteMonitoring.id;
        })
            .toArray()
            .then((dbPlans) => {
                let dbPlansAlwaysInOpenErp = [];

                serverSiteMonitoring.plan_ids.forEach((sp) => {
                    let transformedServerPlan = adaptPlanFromOpenERP(sp);

                    let dbPlan = dbPlans.find(
                        (dbp) => dbp.id === sp.id
                    );

                    dbPlansAlwaysInOpenErp =
                        synchronizePlan(
                            dbPlan,
                            transformedServerPlan,
                            dbPlansAlwaysInOpenErp,
                            serverSiteMonitoring
                        );
                });

                dbPlans.forEach((dbp) => {
                    if (!dbPlansAlwaysInOpenErp.includes(dbp)) deletePlanInDb(dbp);
                });

                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : planActions - synchronizePlans", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la synchronisation des plans !",
                    })
                );
                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function synchronizePlan(
    dbPlan,
    transformedServerPlan,
    dbPlansAlwaysInOpenErp,
    siteMonitoring
) {
    transformedServerPlan.affair_id = siteMonitoring.id;

    if (dbPlan) {
        dbPlansAlwaysInOpenErp.push(dbPlan);

        let transformedPlanForDb = adaptPlanForDb(transformedServerPlan)

        //Pour des raisons de performances, la récupération des pièces jointes est faite via une autre synchronisation (voir getPlansAttachment)
        //Puisque les plans ne sont pas modifiables, on ira chercher que les plans que nous n'avons pas encore sur le périphérique
        //Il faut donc garder le plan sauvegardé dans indexeddb avant de le remplacer par le document du serveur
        delete transformedPlanForDb.file_id;

        db.SiteMonitoringPlan.update(
            transformedServerPlan.id,
            transformedPlanForDb
        );
    } else {
        db.SiteMonitoringPlan.add(adaptPlanForDb(transformedServerPlan));
    }

    return dbPlansAlwaysInOpenErp;
}

export function deletePlanInDb(plan) {
    db.SiteMonitoringPlan.delete(plan.id);
}

export function addAnnotationToPlan(siteMonitoring, note, user, onPlanUpdated) {
    return (dispatch) => {

        let planId = note.annotation.data.planId;

        db.SiteMonitoringPlan.where("id").equals(planId).first((plan) => {
            let newPlan = adaptPlanForMyOpen(plan);
            let annotations = [...newPlan.data];
            annotations = annotations.concat(note.annotation);
            newPlan.data = annotations;
            dispatch(savePlan(siteMonitoring, newPlan, user, onPlanUpdated));
        }).catch((err) => {
            console.error("Erreur : planActions - addAnnotationToPlan")
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération du plan associé à la note !",
            }));
        });
    }
}

export function updateAnnotationToPlan(siteMonitoring, note, user, onPlanUpdated) {
    return (dispatch) => {
        db.SiteMonitoringPlan.filter((plan) => {
            return plan.affair_id === siteMonitoring.id;
        }).toArray().then((plans) => {

            plans.forEach((plan) => {
                let clonedPlan = adaptPlanForMyOpen(plan);
                if (!clonedPlan.data)
                    return;

                let annotation = clonedPlan.data.find((annotation) => {
                    return annotation.data.noteMobileId === note.mobile_id
                });

                if (!annotation)
                    return;

                annotation.data.text = note.name;

                dispatch(savePlan(siteMonitoring, clonedPlan, user, onPlanUpdated));
            })
        }).catch((err) => {
            console.error("Erreur : planActions - updateAnnotationToPlan", err)
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération du plan associé à la note !",
            }));
        });
    }
}

export function actualizeAllAnnotationsLabel(user) {
    return (dispatch) => {
        db.SiteMonitoringPlan.toArray().then((plans) => {
            db.SiteMonitoringNote.toArray().then((allNotes) => {
                plans.forEach(async (plan) => {
                    let siteMonitoring = await getSiteMonitoring(plan.affair_id);
                    let clonedPlan = adaptPlanForMyOpen(plan);
                    if (!clonedPlan.data)
                        return;

                    let planUpdated = false;
                    clonedPlan.data.forEach((annotation) => {

                        let note = allNotes.find((note) => {
                            return annotation.data.noteMobileId === note.mobile_id
                        });

                        if (!note)
                            return;

                        if (annotation.data.text !== note.name) {
                            annotation.data.text = note.name;
                            planUpdated = true;
                        }
                    })

                    if (planUpdated)
                        dispatch(savePlan(siteMonitoring, clonedPlan, user));
                })
            })
        }).catch((err) => {
            console.error("Erreur : planActions - updateAnnotationToPlan", err)
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération du plan associé à la note !",
            }));
        });
    }
}

export async function getPlanFromNote(siteMonitoring, note) {
    return await db.SiteMonitoringPlan.filter((plan) => {
        return plan.affair_id === siteMonitoring.id;
    }).toArray().then((plans) => {
        let matchingPlan = [];

        plans.forEach((plan) => {
            let clonedPlan = adaptPlanForMyOpen(plan);
            if (!clonedPlan.data)
                return;

            let annotation = clonedPlan.data.find((annotation) => {
                return annotation.data.noteMobileId === note.mobile_id
            });

            if (!annotation)
                return;

            matchingPlan.push(plan);
        })

        if (matchingPlan.length > 1)
            console.error("Erreur : planActions - getPlanFromNote - Plusieurs résultats ont été trouvés ce qui n'est pas possible");

        if (!matchingPlan || matchingPlan.length <= 0)
            return null;

        return matchingPlan[0];
    }).catch((err) => {
        console.error("Erreur : planActions - getPlanFromNote", err)
    });
}

export function loadPlan(plan) {
    return (dispatch) => {
        if (window.confirm("Les modifications non sauvegardées sur cette note seront perdues. Voulez-vous vraiment aller sur le plan?")) {
            dispatch(setSelectedTab(PLANS_TAB_INDEX));
            dispatch(clearEditingNote());
            dispatch(setExpandedPlanId(plan.id));
        }
    }
}

export function getPlansAttachment(user) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(siteMonitoringsIsLoading(true))
            db.SiteMonitoringPlan.toArray().then((dbPlans) => {
                let planIdsToDownload = [];

                dbPlans.filter(p => !p.file_id).forEach(dbp => {
                    planIdsToDownload.push(dbp.id)
                })

                if (planIdsToDownload.length <= 0){
                    dispatch(siteMonitoringsIsLoading(false))
                    return resolve();
                }

                const headers = new Headers({ "Content-Type": "application/json" });
                fetchWithTimeout("/api/v1/siteMonitorings/get_plans_attachment", {
                    method: "POST",
                    headers: headers,
                    timeout: 60000,
                    body: JSON.stringify({
                        userId: user.id,
                        planIdsToDownload
                    }),
                })
                    .then((response) => {
                        if (!response.ok)
                            throw Error(response.statusText);

                        return response;
                    })
                    .then((response) => response.json())
                    .then((plans) => {
                        plans.forEach(p => {
                            db.SiteMonitoringPlan.update(p.id, {
                                file_id: p.file_id ? getBase64ImageWithHeader(p.file_id) : ""
                            })
                        })
                        dispatch(siteMonitoringsIsLoading(false))

                        return resolve();
                    }).catch((err) => {
                        console.error(
                            "Erreur : planActions - getPlansAttachment",
                            err
                        );

                        dispatch(
                            throwErrorMessage({
                                errorObject: err,
                                title: "Erreur",
                                message: "Erreur lors de la récupération des plans !",
                            })
                        );

                        dispatch(siteMonitoringsIsLoading(false))
                        return reject()
                    });
            })
        })
    };
}
